import React from "react"

interface ToggleProps {
  label?: string
  onclick?: () => void
  checked?: boolean
  textClassName?: string
  isProcessing?: boolean
}

export default function Toggle({
  onclick,
  label,
  checked = false,
  textClassName = '',
  isProcessing = false
}: ToggleProps) {
  return (
    <label className="toggle nav-item-text">
      <div className="toggle-onclick">
        <span className={textClassName}>{label}</span>
        <span className="switch">
          <input type="checkbox" checked={checked} onClick={onclick} readOnly />
          {isProcessing ?
            <div className="processing">
              <span />
              <span />
              <span />
            </div>
            :
            <span className={`slider`} />
          }
        </span>
      </div>
    </label>
  )
}